import { Badge, Box, Flex, Progress, Text } from '@mantine/core';

import { STEP_STATUS_UI, TRACKING_CONFIGS } from '../../constants/conversionTracking';
import { getTrackingStatusInfo } from '../../utils/getStepStructure';

import type { TrackingType } from '../../types';

interface IPropsProgressSummary {
  trackingType: TrackingType;
  currentProcess: string | null;
  progressCurrent: number;
  progressTotal: number;
}

export default function ProgressSummary(props: IPropsProgressSummary) {
  const { trackingType, currentProcess, progressCurrent, progressTotal } = props;
  const statusInfo = getTrackingStatusInfo(TRACKING_CONFIGS[trackingType], currentProcess);
  const statusUi = STEP_STATUS_UI[statusInfo.stepStatus];

  const progress = progressTotal > 0 ? Math.min((progressCurrent / progressTotal) * 100, 100) : 0;

  return (
    <Box px="md" mb="xl">
      <div>
        <Flex justify="space-between" align="flex-start" gap="md">
          <div>
            <Badge size="lg" color={statusUi.color}>
              {statusUi.label}
            </Badge>
            <Text fw={700} size="xl" mt={8}>
              {statusInfo.progressLabel}
            </Text>
          </div>
        </Flex>
        <div>
          <Text size="sm" ta="right">{`( ${progressCurrent.toLocaleString()} / ${progressTotal.toLocaleString()} )`}</Text>
          <Box pos="relative">
            <Progress.Root size={42} radius="xl">
              <Progress.Section value={progress} color={statusUi.color} />
            </Progress.Root>
            <Text
              c="white"
              fw={700}
              size="xl"
              ta="center"
              style={{
                position: 'absolute',
                top: '50%',
                left: '50%',
                transform: 'translate(-50%, -50%)',
                pointerEvents: 'none',
              }}
            >
              {`${progress.toFixed(1)}%`}
            </Text>
          </Box>
        </div>
      </div>
    </Box>
  );
}
